import Logo from 'assets/img/Logo.svg';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import UserImageProfile from '../user/UserImageProfile';
import GlobalStore from 'stores/globalStore';
import CartContext from 'stores/cart-context';
import Cart from '../Cart/Cart';
import './Header.css';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Header: React.FC = () => {
  const { isNavOpened, toggleNav, signOut } = GlobalStore.useContainer();
  const { t } = useTranslation();
  const cartCtx = useContext(CartContext);

  const handleNavToggle = () => {
    toggleNav();
  };

  const logOutHandler = () => {
    if (cartCtx.emptyCart) {
      cartCtx.emptyCart();
    }
    signOut();
  };

  return (
    <header className="site-header">
      <div className="site-header__inner container">
        <div className="site-header__logo">
          <Link to="http://vn.elsaspeak.com/" target="_blank">
            <img src={Logo} alt="ELSA" />
          </Link>
        </div>

        <div className="navbar-right">
          <div className="header-menu visible-desktop">
            <button
              className="header-menu__logout-btn"
              onClick={logOutHandler}
            >
            {t('logout')}
            </button>
          </div>

          <Cart />
          <div className="header-img-profile hidden-desktop">
            <UserImageProfile />
          </div>

          <LanguageSwitcher />
          
          <button className={'toggle-menu' + (isNavOpened ? ' is-open' : '')} onClick={handleNavToggle}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
